import React from 'react';
import { deliverables } from '../data/content';
import { CTAButton } from './CTAButton';
export function Deliverables() {
  return <section className="w-full bg-navy-900 px-4 py-14 sm:px-6 sm:py-20" data-id="element-100" data-mp="10bw7p3vh794d">
      <div className="mx-auto max-w-3xl" data-id="element-101" data-mp="1e2riilpjc0al">
        <h2 className="text-center font-display text-3xl font-700 uppercase leading-tight text-white sm:text-4xl" data-id="element-102" data-mp="1e3u9suqrs4r1">
          What do you get instantly?
        </h2>

        <ul className="mt-8 grid gap-3 sm:grid-cols-2" data-id="element-103" data-mp="1nym5tu4pejjp">
          {deliverables.map(item => <li key={item.text} className="flex items-center gap-3 rounded-xl border border-white/10 bg-navy-950 px-4 py-3.5" data-id="element-104" data-mp="1j013np5w5psm">
              <span className="text-xl leading-none" aria-hidden="true" data-id="element-105" data-mp="1sygwpxohb94r">
                {item.emoji}
              </span>
              <span className="text-sm font-500 leading-snug text-slate-100" data-id="element-106" data-mp="2nlzu890dr5c">{item.text}</span>
            </li>)}
        </ul>

        <div className="mt-9 rounded-2xl border border-gold-500/30 bg-navy-950 p-5 text-center" data-id="element-107" data-mp="3usg78gts1mge">
          <p className="font-display text-xl font-700 uppercase leading-tight text-slate-300 sm:text-2xl" data-id="element-108" data-mp="3k30wqemd6x1f">
            Any complex DVO case that walks into your practice…
          </p>
          <p className="mt-2 font-display text-2xl font-700 uppercase leading-tight text-gold-400 sm:text-3xl" data-id="element-109" data-mp="3u1p50lojrxrx">
            You now have a structured way to approach the assessment.
          </p>
          <p className="mt-3 text-sm text-slate-300" data-id="element-110" data-mp="7n5mqdwgbyg6">
            Download it today and use the system on your next case.
          </p>
        </div>

        <div className="mx-auto mt-7 max-w-md" data-id="element-111" data-mp="gon2fv5y5y4c">
          <CTAButton label="Get instant access now" subtext="One-time payment · Lifetime access · 7-day guarantee" data-id="element-112" data-mp="gowrngj6418z" />
        </div>
      </div>
    </section>;
}